import React from 'react'

import { pantryColors } from '../../../foundations/tokens'

type AvatarSize = 'sm' | 'md' | 'lg'

export interface InitialsAvatarProps {
  initials: string
  color?: string
  size?: AvatarSize
}

const sizeStyles: Record<AvatarSize, React.CSSProperties> = {
  sm: { width: 28, height: 28, fontSize: 12 },
  md: { width: 36, height: 36, fontSize: 14 },
  lg: { width: 48, height: 48, fontSize: 16 },
}

export const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  initials,
  color = pantryColors.brand.primary,
  size = 'md',
}) => {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        fontWeight: 700,
        color: pantryColors.white,
        flexShrink: 0,
        textTransform: 'uppercase',
        background: color,
        ...sizeStyles[size],
      }}
    >
      {initials.slice(0, 2)}
    </span>
  )
}
